/**
 * FAQ 页：10 个分类 × 每类 5 个问题（共 50 条）
 */

/** 从分类数据生成 FAQPage Schema */
export function buildFaqPageSchema(categories) {
	const all = categories.flatMap((cat) => cat.items);
	return {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: all.map((item) => ({
			'@type': 'Question',
			name: item.q,
			acceptedAnswer: {
				'@type': 'Answer',
				text: item.a,
			},
		})),
	};
}

export const FAQ_CATEGORIES = [
	{
		id: 'general',
		h2: 'General Questions About GB WhatsApp',
		footerLinks: [
			{ to: '/', text: 'GB WhatsApp home guide' },
			{ to: '/download/', text: 'Download GB WhatsApp APK' },
		],
		items: [
			{
				q: 'What is GB WhatsApp?',
				a: 'GB WhatsApp is a modified Android client built on WhatsApp’s protocol. It adds privacy switches, themes, larger media limits, and tools that official WhatsApp does not ship in the Play Store build. It is not published or supported by Meta.',
			},
			{
				q: 'How does GB WhatsApp work?',
				a: 'After you install the APK and verify your phone number, GB WhatsApp connects to WhatsApp servers like the official app. Extra menus and settings are layered on top by the mod developer. Updates come from APK files, not Google Play.',
			},
			{
				q: 'What can GB WhatsApp do?',
				a: 'Common extras include hiding online status and blue ticks, downloading statuses, custom themes, extended file sizes, and anti-delete message options on some builds. Exact tools depend on the version you install.',
			},
			{
				q: 'Who is the owner of GB WhatsApp?',
				a: 'GB WhatsApp is maintained by independent mod developers, not Meta. Brand names belong to their respective owners. GBWaps is an informational site and does not claim to own the app.',
			},
			{
				q: 'Does GB WhatsApp still exist?',
				a: 'Yes. New APK builds are released regularly under names like GBWhatsApp, GBWA, or similar forks. Always download the latest build from a source you trust and avoid dead mirror links.',
			},
		],
	},
	{
		id: 'download',
		h2: 'Download & APK Questions',
		footerLinks: [
			{ to: '/', text: 'GB WhatsApp overview' },
			{ to: '/download/', text: 'Download GB WhatsApp' },
		],
		items: [
			{
				q: 'How to download GB WhatsApp?',
				a: 'Open our download page on an Android phone or PC, save the APK, then transfer it to your phone if needed. Confirm file size and version before installing. Do not install from random popup ads.',
			},
			{
				q: 'How can I download GB WhatsApp APK?',
				a: 'Tap the download button on the GBWaps download hub. Use your browser or file manager to open the saved APK. Enable “Install unknown apps” for that app when Android asks.',
			},
			{
				q: 'How to download GB WhatsApp latest version?',
				a: 'Check the version number on our download page (for example v18.80) and match it on the file you save. Older APKs may fail login or miss recent anti-ban patches from the developer.',
			},
			{
				q: 'Is GB WhatsApp free to download?',
				a: 'The APK is typically free. Some third-party sites charge or bundle malware—avoid them. GBWaps does not sell the app; we list file info and safety notes only.',
			},
			{
				q: 'How to find GB WhatsApp download safely?',
				a: 'Use known sites with clear version labels, avoid shortened links in social DMs, scan the APK with Play Protect or VirusTotal when possible, and never grant accessibility to unknown “helper” apps.',
			},
		],
	},
	{
		id: 'installation',
		h2: 'Installation & Setup Questions',
		footerLinks: [
			{ to: '/install-gbwhatsapp/', text: 'How to install GB WhatsApp' },
			{ to: '/download/', text: 'Download APK' },
		],
		items: [
			{
				q: 'How to install GB WhatsApp on Android?',
				a: 'Download the APK, allow installs from your browser or Files app, open the package, and follow on-screen steps. You will verify your number again. See our install guide for screenshots and permission tips.',
			},
			{
				q: 'How to install GB WhatsApp without losing chats?',
				a: 'Back up chats inside WhatsApp settings before switching. Install over an existing mod with the same package name when possible. If you uninstall official WhatsApp first, restore from Google Drive or local backup during setup.',
			},
			{
				q: 'How to open GB WhatsApp after installation?',
				a: 'Find the GBWhatsApp icon in your app drawer. On first launch, accept permissions for contacts and storage, then enter your country code and phone number to receive the SMS or call verification code.',
			},
			{
				q: 'How to activate GB WhatsApp?',
				a: 'Activation means completing phone verification and optional restore from backup. Use the same number you want on the mod. If the code never arrives, wait a few minutes and check troubleshooting steps.',
			},
			{
				q: 'How to set up GB WhatsApp after install?',
				a: 'Restore backup if prompted, set your profile photo and name, then open GB settings (often via menu ⋮) to tune privacy and anti-ban options. Start with conservative settings before enabling every hide feature.',
			},
		],
	},
	{
		id: 'safety',
		h2: 'Safety & Privacy Questions',
		footerLinks: [
			{ to: '/', text: 'GB WhatsApp safety overview' },
			{ to: '/anti-ban/', text: 'Anti-ban guide' },
		],
		items: [
			{
				q: 'Is GB WhatsApp safe to use?',
				a: 'Safety depends on APK source, device security, and how you use the mod. Unofficial apps are not audited by Meta. Download from trusted pages, keep Android updated, and avoid entering sensitive accounts you cannot afford to lose.',
			},
			{
				q: 'Is GB WhatsApp safe for video calls?',
				a: 'Calls still use WhatsApp infrastructure, but mods can add unknown code paths. For highly private calls, many users prefer the official app. Keep the mod updated and do not sideload extra plugins.',
			},
			{
				q: 'Is using GB WhatsApp safe in 2026?',
				a: 'Millions still use mods, but ban and malware risks remain. Use the latest APK, moderate forwarding, and a secondary number if you are testing. Read our anti-ban guide before enabling aggressive privacy toggles.',
			},
			{
				q: 'Is GB WhatsApp banned?',
				a: 'The app is not sold on Google Play and Meta discourages unofficial clients. Accounts can be temporarily or permanently restricted. That is different from the app being illegal in every country—check local laws yourself.',
			},
			{
				q: 'Can I use GB WhatsApp safely?',
				a: 'Many users do with backups and careful habits: update often, avoid mass spam, do not mix unknown plugins, and keep work or banking conversations on official WhatsApp if policy requires it.',
			},
		],
	},
	{
		id: 'ban',
		h2: 'Ban & Anti-Ban Questions',
		footerLinks: [{ to: '/anti-ban/', text: 'GB WhatsApp anti-ban guide' }],
		items: [
			{
				q: 'Can we use GB WhatsApp after ban?',
				a: 'Temporary bans usually lift after the countdown. Permanent bans may block that number on WhatsApp entirely. Switching to a mod again on a fresh number without fixing habits often leads to another ban.',
			},
			{
				q: 'How to use GB WhatsApp without getting banned?',
				a: 'Update to the latest build, avoid bulk forwarding and unknown link blasts, keep anti-ban settings at recommended levels, and warm up new numbers with normal chat patterns before heavy automation.',
			},
			{
				q: 'How to unban GB WhatsApp?',
				a: 'If Meta shows “temporarily banned,” wait it out and do not reinstall repeatedly. For “permanent” messages, appeal through official WhatsApp help if available, or use a new number only where terms allow.',
			},
			{
				q: 'Why do WhatsApp accounts get banned?',
				a: 'Reasons include spam reports, automated messaging, suspicious login, outdated mod signatures, or policy violations. Meta does not publish every rule, so follow community best practices and official Terms of Service.',
			},
			{
				q: 'How does anti-ban work in GB WhatsApp?',
				a: 'Developers patch how the client identifies itself to servers and may throttle risky actions. No setting guarantees zero bans. Treat anti-ban as risk reduction, not a warranty.',
			},
		],
	},
	{
		id: 'features',
		h2: 'Features & Usage Questions',
		footerLinks: [{ to: '/features/', text: 'Full GB WhatsApp features list' }],
		items: [
			{
				q: 'How to hide blue ticks in GB WhatsApp?',
				a: 'Open GB settings → Privacy → disable read receipts or use “hide blue ticks” if your build labels it that way. Recipients may still see delivery ticks depending on their client.',
			},
			{
				q: 'How to hide online status in GB WhatsApp?',
				a: 'Go to privacy settings and turn off “online” or enable “freeze last seen.” Some builds let you stay online while appearing offline to others. Test with a friend account before relying on it.',
			},
			{
				q: 'How to send large videos on GB WhatsApp?',
				a: 'Many mods raise the media cap above official limits. Compress very large files if upload fails, check mobile data limits, and ask the receiver to update their mod if they cannot download.',
			},
			{
				q: 'How to add stickers in GB WhatsApp?',
				a: 'Use the sticker panel like official WhatsApp, plus extra packs from GB menus on some versions. Import third-party packs only from sources you trust to avoid malformed files.',
			},
			{
				q: 'How to lock chats in GB WhatsApp?',
				a: 'Open chat → menu → lock chat, or use GB privacy → fingerprint/PIN lock. Set a recovery email or PIN you will remember; losing it can block access to locked threads.',
			},
		],
	},
	{
		id: 'detection',
		h2: 'Detection & User Behavior Questions',
		footerLinks: [
			{ to: '/features/', text: 'Privacy & feature tools' },
			{ to: '/faq/', text: 'More FAQ answers' },
		],
		items: [
			{
				q: 'How to know if someone is using GB WhatsApp?',
				a: 'There is no official public badge. Clues might include unusual last-seen behavior, extra-long videos, or custom themes in forwarded media—not proof by themselves.',
			},
			{
				q: 'Can GB WhatsApp detect hidden status?',
				a: 'Some builds expose extra status viewing options. Ethics and local law matter: viewing hidden content without consent can violate trust or policy. Use features responsibly.',
			},
			{
				q: 'How to find GB WhatsApp users?',
				a: 'You cannot search a global directory. You only chat with contacts who already use WhatsApp or GB on their number. Invite friends by sharing your number normally.',
			},
			{
				q: 'How to check someone using GB WhatsApp?',
				a: 'Avoid third-party “detector” apps—they are often scams. Direct ask or observe consistent mod-only features is safer than installing spyware tools.',
			},
			{
				q: 'Can people detect GB WhatsApp?',
				a: 'Power users may guess from message metadata or call UI differences. Meta may detect unofficial clients server-side even if friends cannot see which mod you use.',
			},
		],
	},
	{
		id: 'troubleshooting',
		h2: 'Troubleshooting & Problems',
		footerLinks: [{ to: '/troubleshooting/', text: 'GB WhatsApp troubleshooting guide' }],
		items: [
			{
				q: 'Why is GB WhatsApp not working?',
				a: 'Causes include outdated APK, corrupted install, low storage, or server outages. Update or reinstall from our download page, clear cache, and check Android version meets minimum requirements.',
			},
			{
				q: 'How to fix GB WhatsApp crashing?',
				a: 'Clear app cache, reboot the phone, install the latest APK over the old one, and disable battery optimization killers for GBWhatsApp. If crashes persist, back up and reinstall cleanly.',
			},
			{
				q: 'Why is verification code not received?',
				a: 'Check signal, airplane mode, SMS filters, and that you entered the correct country code. Request call verification, wait before retrying, and avoid too many attempts in one hour.',
			},
			{
				q: 'How to fix installation failed error?',
				a: 'Enable unknown sources for the installer app, free storage space, uninstall conflicting clones, and delete a broken partial install before trying a fresh APK download.',
			},
			{
				q: 'Why messages are not sending in GB WhatsApp?',
				a: 'Test Wi-Fi and mobile data, confirm you are not banned, check WhatsApp service status, and update the mod. Clock skew on the device can also break encryption—enable automatic date and time.',
			},
		],
	},
	{
		id: 'device',
		h2: 'Device & Compatibility',
		footerLinks: [
			{ to: '/download/', text: 'Download for Android' },
			{ to: '/install-gbwhatsapp/', text: 'Installation requirements' },
		],
		items: [
			{
				q: 'Does GB WhatsApp work on Android?',
				a: 'Yes. GB WhatsApp is an APK for Android phones and tablets. Most builds support Android 4.4 and up; newer versions run best on Android 8+ with enough RAM and storage.',
			},
			{
				q: 'Does GB WhatsApp work on iPhone?',
				a: 'No official GB APK exists for iPhone. iOS does not allow this sideload pattern without jailbreak, which is risky and unsupported here. Use official WhatsApp on iOS.',
			},
			{
				q: 'What Android version is required?',
				a: 'Our current guide lists Android 4.4+ for v18.80. Features like scoped storage on Android 11+ may need extra permission steps during install. Check the download page for the latest requirement line.',
			},
			{
				q: 'Can I use GB WhatsApp on multiple devices?',
				a: 'WhatsApp allows linked devices on official apps; mods vary. Often one primary phone holds the main session. Read your build’s notes before expecting full multi-device parity.',
			},
			{
				q: 'Is GB WhatsApp available for iOS?',
				a: 'Not as a safe mainstream download. App Store only hosts official WhatsApp. Ignore sites promising “GB WhatsApp iOS IPA” unless you fully accept jailbreak and security risks.',
			},
		],
	},
	{
		id: 'update',
		h2: 'Update & Maintenance',
		footerLinks: [
			{ to: '/gbwhatsapp-update/', text: 'GB WhatsApp update guide' },
			{ to: '/download/', text: 'Latest APK download' },
		],
		items: [
			{
				q: 'How to update GB WhatsApp?',
				a: 'Back up chats, download the newest APK from our download or update page, and install over the existing app without uninstalling. Open the app and confirm the version in settings.',
			},
			{
				q: 'How to check GB WhatsApp version?',
				a: 'Open GB settings → Help → App info, or About. Compare the number with the version published on GBWaps. Mismatched builds are a common cause of login errors.',
			},
			{
				q: 'How to reinstall GB WhatsApp safely?',
				a: 'Back up locally and to Google Drive if you use it, download a fresh APK, uninstall only if an overlay install fails, then reinstall and restore backup when prompted.',
			},
			{
				q: 'How to uninstall GB WhatsApp?',
				a: 'Android Settings → Apps → GBWhatsApp → Uninstall. Chats may remain in backup files on storage or Drive. Export important media before removing the app.',
			},
			{
				q: 'How to restore GB WhatsApp backup?',
				a: 'During setup, tap Restore when asked and pick Google Drive or local backup. Use the same phone number. If restore fails, check storage permissions and backup file date.',
			},
		],
	},
];

export const FAQ_PAGE_FULL_SCHEMA = buildFaqPageSchema(FAQ_CATEGORIES);
